const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:4010';

export function getApiBaseUrl(): string {
  return API_BASE_URL.replace(/\/+$/, '');
}
